export default function getChangesByCellLocation(e){

  //targetLocations:{nodeId,cellLocation}
  let { targetLocations, properties } = e;

  if( !targetLocations ){
    debugger;
  }


  let byCell = {};

  //need to replace . with ~ so we can 
  //put the '.' at the front with the nodeOverrides.nodeId
  let fixedPropertyEntries = Object.entries(properties).map(([key,value]) => {
    return [key.replaceAll('.','~'),value]
  });


  targetLocations.forEach(({cellLocation,nodeId}) => {

    let cellLoci = cellLocation.join('-');
    if( !byCell[ cellLoci ] ){
      byCell[ cellLoci ] = {}
    }


    //set the properties to be set in each cell
    fixedPropertyEntries.forEach(([key,value]) => {
      let finalKey = `nodeOverrides.${nodeId}.${key}`;
      byCell[ cellLoci ][ finalKey ] = value;
    })
  })


  let byCellLocation = Object.entries(byCell).map(([cellKey,properties]) => {
    return { 
      cellLocation:cellKey.split('-').map(Number),
      properties
    }
  })

  return byCellLocation;

}
